module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (266).a66378de.jpg";